import * as basicLightbox from 'basiclightbox';
import Cookies from 'js-cookie';

export default function () {

    const contents = document.querySelector(".mainpage-popup-contents");
    if (!contents) return;

    if (window.currentModalInstance) {
        window.currentModalInstance.close();
    }

    const mainpagePopup = basicLightbox.create(`
                        <div class="modal-form-content">
                            <div class="goshop-modal goshop-modal-form">
                                ${contents.innerHTML}
                                <span class="goshop-modal-close"></span>
                            </div>
                        </div>
                    `, {
        onClose: () => {
                            Cookies.set('mainpage_modal_closed', '1', { expires: 1 });
                            window.currentModalInstance = null;

        }
    });
    window.currentModalInstance = mainpagePopup;
    mainpagePopup.show();
}